/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getCurrentDate = () => {
    const nowDate = new Date();
    nowDate.setHours(0, 0, 0, 0);
    return nowDate;
};

export const dateFn = {
    getCurrentDate,
};

export const DaysOfTheWeekShort = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const DaysOfTheWeekFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const MonthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const MonthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const addLeadingZero = (n) => {
    /* eslint-disable no-param-reassign */
    n = n.toString();
    if (n.length < 2) {
        return `0${n}`;
    }
    return n;
};

/**
 * converts date string 13-Aug-21 to 2012/08/13
 * converts date string 05/30/2023 00:00:00 to 2023/30/05
 * @param {string} dateString eg: 13-Aug-21 or 05/30/2023 00:00:00
 * @returns 2023/30/05
 */
export const formatDateDDMMYYToYYYYMMDD = (dateString) => {
    if (dateString && dateString.indexOf('-') > 0) {
        const splitDate = dateString.split('-');

        const dateDay = addLeadingZero(splitDate[0]);
        const dateMonth = addLeadingZero(MonthShort.indexOf(splitDate[1]) + 1);
        const dateYear = `20${splitDate[2]}`;

        return `${dateYear}/${dateMonth}/${dateDay}`;
    } if (dateString && dateString.indexOf('/') > 0) {
        let splitDate = dateString.split(' ')?.[0] || null;
        splitDate = splitDate.split('/') || null;

        if (splitDate) {
            const dateDay = addLeadingZero(splitDate[1]);
            const dateMonth = addLeadingZero(splitDate[0]);
            const dateYear = splitDate[2];
            return `${dateYear}/${dateMonth}/${dateDay}`;
        }
    }

    return '';
};

export const getDaysBreakDown = (startDate, endDate) => {
    const loopDate = new Date(startDate);
    const loopEndDate = new Date(endDate);
    loopEndDate.setDate(loopEndDate.getDate() + 1);
    const dateCollection = {};
    let tempYear = '';
    let tempMonth = '';
    let tempWeek = '';
    while (loopEndDate.toDateString() !== loopDate.toDateString()) {
        const year = addLeadingZero(loopDate.getFullYear());
        const month = addLeadingZero((loopDate.getMonth() + 1));
        const day = addLeadingZero(loopDate.getDate());
        let firstDayOfWeek = new Date(loopDate.getFullYear(), loopDate.getMonth(), loopDate.getDate());
        firstDayOfWeek.setDate(firstDayOfWeek.getDate() - firstDayOfWeek.getDay());
        firstDayOfWeek = `${firstDayOfWeek.getFullYear()}-${addLeadingZero(firstDayOfWeek.getMonth() + 1)}-${addLeadingZero(firstDayOfWeek.getDate())}`;
        const dayOfTheWeek = loopDate.getDay().toString();
        const strDayOfTheWeek = DaysOfTheWeekShort[dayOfTheWeek];
        const strDate = `${year}-${month}-${day}`;
        if (tempYear !== year) {
            dateCollection[year] = {};
            tempYear = year;
            tempMonth = '';
        }
        if (tempMonth !== month) {
            dateCollection[year][month] = {};
            tempMonth = month;
            tempWeek = '';
        }
        if (tempWeek !== firstDayOfWeek) {
            dateCollection[year][month][firstDayOfWeek] = {};
            tempWeek = firstDayOfWeek;
        }
        dateCollection[year][month][firstDayOfWeek][dayOfTheWeek] = {
            date: strDate,
            day: strDayOfTheWeek,
            dateObj: new Date(loopDate.getFullYear(), loopDate.getMonth(), loopDate.getDate()),
        };
        loopDate.setDate(loopDate.getDate() + 1);
    }
    return dateCollection;
};

export const shrinkCalendarDate = (dateCollection, WeekCapPerMonth) => {
    const Year = Object.keys(dateCollection).sort();
    const shrinkDates = {};
    let breakLoop = false;
    // eslint-disable-next-line consistent-return
    Year.forEach((year) => {
        if (breakLoop) return true;
        const LYear =  year;
        const MonthsInYear = Object.keys(dateCollection[LYear]).sort();
        shrinkDates[LYear] = {};
        // eslint-disable-next-line consistent-return
        MonthsInYear.forEach((month) => {
            if (breakLoop) return true;
            const LMonth =  month;
            const MonthWeeks = dateCollection[LYear][LMonth];
            shrinkDates[LYear][LMonth] = { ...dateCollection[LYear][LMonth] };
            /*
                Exit If the month has more than 3 weeks, to keep the calendar to have one month per view
                IF a month does not have more than 3 weeks then include next month to view.
            */
            if (Object.keys(MonthWeeks).length > WeekCapPerMonth) {
                breakLoop = true;
            }
        });
    });
    return shrinkDates;
};

export const getDateStringBtn = (startDate, endDate) => {
    const loopDate = new Date(startDate);
    endDate = endDate.setDate(endDate.getDate() + 1);
    const loopEndDate = new Date(endDate);
    const dateRange = [];
    while (loopEndDate.toDateString() !== loopDate.toDateString()) {
        dateRange.push(new Date(loopDate));
        loopDate.setDate(loopDate.getDate() + 1);
    }
    return dateRange;
};

export const getDeliveryDates = (calendarDates) => {
    let temp = '';
    const deliveryMonthsToShow = {};
    calendarDates.forEach((dateDetails) => {
        const delDate = dateDetails.deliveryDate;
        if (temp !== delDate) {
            temp = delDate;
            deliveryMonthsToShow[delDate] = [];
        }
        deliveryMonthsToShow[delDate].push(dateDetails);
    });
    return deliveryMonthsToShow;
};

export const getHolidayDates = (calendarDates) => {
    let temp = '';
    const holidayDays = {};
    calendarDates.forEach((dateDetails) => {
        const delHolidayCode = dateDetails.holidayCode;
        if (temp !== delHolidayCode) {
            temp = delHolidayCode;
            holidayDays[delHolidayCode] = [];
        }
        holidayDays[delHolidayCode].push(dateDetails);
    });
    return holidayDays;
};

export const convertToDateObj = (dateStr) => {
    const tempDate = dateStr.split('-'); // YY-mm-dd
    const date = tempDate[2];
    const month = (parseInt(tempDate[1], 10) - 1);
    const year = tempDate[0];
    const dateObj = new Date(year, month, date);
    return dateObj;
};

export const convertDateObjToDateStr = (dateObj) => {
    const date = addLeadingZero(dateObj.getDate());
    const month = addLeadingZero((parseInt(dateObj.getMonth(), 10) + 1));
    const year = dateObj.getFullYear();
    return `${year}-${month}-${date}`;
};

export const returnPreviousWeekEndDate = (date) => {
    const prvWeekEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    prvWeekEndDate.setDate(date.getDate() - (date.getDay() + 1));
    return prvWeekEndDate;
};

export const getDateDiff = (date1, date2) => {
    const diffInTime = date2.getTime() - date1.getTime();
    const diffInDays = (diffInTime / (1000 * 3600 * 24)) + 1;
    return diffInDays;
};

export const roundDateCalendarStartAndEndDate = (startDate, endDate) => {
    const returnDate = { startDate, endDate };
    const FirstDayOfMonthOfStartDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const LastDayOfMonthOfStartDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    const startAndEndDateDiff = getDateDiff(startDate, endDate);
    const startDateFirstAndLastDateDiff = getDateDiff(FirstDayOfMonthOfStartDate, LastDayOfMonthOfStartDate);

    let roundToEndOfMonth = false;
    if (startAndEndDateDiff < startDateFirstAndLastDateDiff) {
        roundToEndOfMonth = true;
    }
    // Round Start Date
    const objCurDate = dateFn.getCurrentDate();
    if (objCurDate < startDate) {
        if ((objCurDate.getMonth() === startDate.getMonth()) && (objCurDate.getFullYear() === startDate.getFullYear())) {
            returnDate.startDate = new Date(objCurDate);
        } else {
            returnDate.startDate = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
        }
    }
    // Round End Date
    if (roundToEndOfMonth) {
        returnDate.endDate = LastDayOfMonthOfStartDate;
    } else {
        const isEndDateEndOfWeek = (endDate.getDay() === 6);
        if (!isEndDateEndOfWeek) {
            const prvWeekEndDate = returnPreviousWeekEndDate(endDate);
            const endOfMonth =  new Date(prvWeekEndDate.getFullYear(), prvWeekEndDate.getMonth() + 1, 0);
            if (endDate.getTime() >= endOfMonth.getTime()) {
                returnDate.endDate = endOfMonth;
            } else {
                returnDate.endDate = prvWeekEndDate;
            }
        }
    }
    return returnDate;
};
